import { isBrowser } from "~/utilities/helpers";

export const setStickyTableHeader = (
    tableRef,
    tableHeaderRef,
    stickyItemsHeight,
) => {
    const stickyHeight = stickyItemsHeight ?? 0;
    const tableWrapperEl = tableRef.current.parentNode;
    const tableTop = tableWrapperEl.getBoundingClientRect().top;
    const windowHeight = Math.max(
        document.documentElement.clientHeight,
        isBrowser ? window.innerHeight : 0,
    );
    const tableHeight = tableWrapperEl.clientHeight;
    const isInViewPort =
        tableTop < windowHeight && tableTop + tableHeight > stickyHeight;

    if (isInViewPort) {
        tableHeaderRef.current.childNodes.forEach((th) => {
            if (tableTop < stickyHeight) {
                th.style.top = `${Math.abs(tableTop - stickyHeight)}px`;
            } else {
                th.style.top = 0;
            }
        });
    }
};

export const setScrollbarWidth = (tableRef, scrollBarRef) => {
    if (!tableRef.current || !scrollBarRef.current) return;

    const tableElement = tableRef.current;
    const scrollBarElement = scrollBarRef.current;
    const tableWidth = tableElement.offsetWidth;

    scrollBarElement.style.width = `${tableWidth}px`;
};

export const checkIsMac = () => {
    if (isBrowser) {
        const platform =
            window.navigator?.userAgentData?.platform ||
            window.navigator?.platform;
        const macosPlatforms = [
            "Macintosh",
            "MacIntel",
            "MacPPC",
            "Mac68K",
            "macOS",
        ];

        if (macosPlatforms.includes(platform)) {
            return true;
        }

        return false;
    }

    return false;
};

export const verticalScrollListener = (
    e,
    windowScrollY,
    tableRef,
    tableHeaderRef,
    totalHeight,
) => {
    const target = e.currentTarget;
    if (
        windowScrollY !== target.scrollY &&
        tableRef?.current &&
        tableHeaderRef?.current
    ) {
        setStickyTableHeader(tableRef, tableHeaderRef, totalHeight);
    }

    windowScrollY.current = target.scrollY;
};

export const setScrollStates = (
    tableWrapperRef,
    useStickyScrollbar,
    verticalScrollExists,
    dispatch,
    tableRef,
    scrollBarRef,
) => {
    if (tableWrapperRef) {
        const horizontalScroll =
            tableWrapperRef.scrollWidth > tableWrapperRef.clientWidth;
        const verticalScroll =
            tableWrapperRef.scrollHeight > tableWrapperRef.clientHeight;

        if (
            useStickyScrollbar !== horizontalScroll ||
            verticalScrollExists !== verticalScroll
        ) {
            dispatch({
                type: "SET_SCROLL_STATES",
                useStickyScrollbar: horizontalScroll,
                verticalScrollExists: verticalScroll,
            });
        }

        setScrollbarWidth(tableRef, scrollBarRef);
    }
};
